import _slicedToArray from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { instrumentMethod } from '@datadog/browser-core';
import { IncrementalSource } from '../../../types';
import { getSerializedNodeId, hasSerializedNode } from '../serialization';
import { assembleIncrementalSnapshot } from '../assembly';
export function trackStyleSheet(styleSheetCb) {
  function checkStyleSheetAndCallback(styleSheet, callback) {
    if (styleSheet && hasSerializedNode(styleSheet.ownerNode)) {
      callback(getSerializedNodeId(styleSheet.ownerNode));
    }
  }
  var instrumentationStoppers = [instrumentMethod(CSSStyleSheet.prototype, 'insertRule', function (_ref) {
    var styleSheet = _ref.target,
      _ref$parameters = _slicedToArray(_ref.parameters, 2),
      rule = _ref$parameters[0],
      index = _ref$parameters[1];
    checkStyleSheetAndCallback(styleSheet, function (id) {
      return styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
        id: id,
        adds: [{
          rule: rule,
          index: index
        }]
      }));
    });
  }), instrumentMethod(CSSStyleSheet.prototype, 'deleteRule', function (_ref2) {
    var styleSheet = _ref2.target,
      _ref2$parameters = _slicedToArray(_ref2.parameters, 1),
      index = _ref2$parameters[0];
    checkStyleSheetAndCallback(styleSheet, function (id) {
      return styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
        id: id,
        removes: [{
          index: index
        }]
      }));
    });
  })];
  if (typeof CSSGroupingRule !== 'undefined') {
    instrumentGroupingCSSRuleClass(CSSGroupingRule);
  } else {
    instrumentGroupingCSSRuleClass(CSSMediaRule);
    instrumentGroupingCSSRuleClass(CSSSupportsRule);
  }
  function instrumentGroupingCSSRuleClass(cls) {
    instrumentationStoppers.push(instrumentMethod(cls.prototype, 'insertRule', function (_ref3) {
      var styleSheet = _ref3.target,
        _ref3$parameters = _slicedToArray(_ref3.parameters, 2),
        rule = _ref3$parameters[0],
        index = _ref3$parameters[1];
      checkStyleSheetAndCallback(styleSheet.parentStyleSheet, function (id) {
        var path = getPathToNestedCSSRule(styleSheet);
        if (path) {
          path.push(index || 0);
          styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
            id: id,
            adds: [{
              rule: rule,
              index: path
            }]
          }));
        }
      });
    }), instrumentMethod(cls.prototype, 'deleteRule', function (_ref4) {
      var styleSheet = _ref4.target,
        _ref4$parameters = _slicedToArray(_ref4.parameters, 1),
        index = _ref4$parameters[0];
      checkStyleSheetAndCallback(styleSheet.parentStyleSheet, function (id) {
        var path = getPathToNestedCSSRule(styleSheet);
        if (path) {
          path.push(index);
          styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
            id: id,
            removes: [{
              index: path
            }]
          }));
        }
      });
    }));
  }
  return {
    stop: function stop() {
      instrumentationStoppers.forEach(function (stopper) {
        return stopper.stop();
      });
    }
  };
}
export function getPathToNestedCSSRule(rule) {
  var path = [];
  var currentRule = rule;
  while (currentRule.parentRule) {
    var _rules = Array.from(currentRule.parentRule.cssRules);
    var _index = _rules.indexOf(currentRule);
    path.unshift(_index);
    currentRule = currentRule.parentRule;
  }
  // A rule may not be attached to a stylesheet
  if (!currentRule.parentStyleSheet) {
    return;
  }
  var rules = Array.from(currentRule.parentStyleSheet.cssRules);
  var index = rules.indexOf(currentRule);
  path.unshift(index);
  return path;
}